export default "__VITE_ASSET__BiyB$qxP__"